import React from 'react';
export var HttpContext = React.createContext({});
//# sourceMappingURL=context.js.map